import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import appstore from './modules/appstore'

import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    appstore
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js